/**
 * @module tree/mutations
 */

import never from '../utils/never.js'
import object from '../utils/object.js'
import dispatcher from '../utils/dispatcher.js'

const dispatch = function (
  records
) {
  for (const record of records) {
    this.dispatch(record)
  }
}

const register = async function* (
  target,
  options
) {
  const mutations = object(dispatcher)
  const records = mutations.subscribe()
  const { ownerDocument } = target
  const { defaultView } = ownerDocument ?? target
  const { MutationObserver } = defaultView
  const observer = new MutationObserver(dispatch.bind(mutations))

  observer.observe(target, options)

  try {
    yield* records
  } finally {
    observer.disconnect()
    await records.return(null)
  }
}

/**
 * Returns an asynchronous iterator of mutation records
 * @param {Element|DocumentFragment} target
 * @param {{}} options
 * @param {?Promise<*>} abort The abortion promise
 * @returns {AsyncGenerator<MutationRecord>}
 */
export default (
  target,
  options,
  abort = never
) => {
  const records = register(target, options)

  if (abort !== never) {
    queueMicrotask(async () => {
      await abort
      await records.return()
    })
  }

  return records
}

